import EventHandler from '@pixelunion/events';
import { CountryProvinceSelector } from '@shopify/theme-addresses';
import QuantitySelector from '../helpers/QuantitySelector';
import GalleryModal from '../components/GalleryModal';

export default class Cart {
  constructor(section) {
    this.el = section.el;
    this.modal = new GalleryModal();
    this.events = new EventHandler();
    this.tos = this.el.querySelector('[data-tos]');
    this.form = this.el.querySelector('#cart_form');
    this.rates = document.querySelector('[data-shipping-rates]');
    this.cartSubmit = this.el.querySelector('[data-cart-submit]');
    this.images = document.querySelectorAll('[data-gallery-modal]');
    this.message = document.querySelector('[data-shipping-message]');
    this.inputFields = this.el.querySelectorAll('[data-quantity-input]');
    this.zip = document.querySelector('[data-shipping-calculator-zipcode]');
    this.submit = document.querySelector('[data-shipping-calculator-submit]');
    this.response = document.querySelector('[data-shipping-calculator-response]');
    this.countrySelect = document.querySelector('[data-shipping-calculator-country]');
    this.provinceSelect = document.querySelector('[data-shipping-calculator-province]');
    this.provinceContainer = document.querySelector('[data-shipping-calculator-province-container]');


    this.quantitySelectors = [];

    this.inputFields.forEach(input => {
      this.quantitySelectors.push(new QuantitySelector({
        quantityField: input.parentNode,
        onChange: () => this.form.submit(),
      }));
    });

    this.events.register(this.cartSubmit, 'click', () => {
      if (this.tos.length) {
        if (this.tos.checked === true) {
          this.form.submit();
        } else {
          alert(Shopify.translation.agree_to_terms_warning);
        }
      } else {
        this.form.submit();
      }
    });

    if (this.images.length > 0) {
      this.initModal();
    }

    if ( Shopify.theme_settings.shipping_calculator ) {
      this.buildCalculator();
    }
  }

  initModal() {
    this.images.forEach((image, selectedIndex) => {
      const { href, dataset } = image;
      const item = {
        src: href,
        w: dataset.imageWidth,
        h: dataset.imageHeight,
      };

      this.imageArray.push(item);
      this.events.register(image, 'click', e => {
        e.preventDefault();
        this.modal.init(this.imageArray, selectedIndex);
      });
    });
  }

  buildCalculator() {
    this.shippingCountryProvinceSelector = new CountryProvinceSelector(this.countrySelect.innerHTML);
    this.shippingCountryProvinceSelector
      .build(
        this.countrySelect,
        this.provinceSelect,
        {
          onCountryChange: provinces => {
            if (provinces.length) {
              this.provinceContainer.style.display = 'block';
            } else {
              this.provinceContainer.style.display = 'none';
            }

            // "Province", "State", "Region", etc. and "Postal Code", "ZIP Code", etc.
            // Even countries without provinces include a label.
            const { label, zip_label: zipLabel } = window.Countries[this.countrySelect.value];
            this.provinceContainer.querySelector('label[for="address_province"]').innerHTML = label;
            this.el.querySelector('label[for="address_zip"]').innerHTML = zipLabel;
          },
        },
      );

    this.events.register(this.submit, 'click', e => {
      e.preventDefault();
      this.getRates();
    });
  }

  getRates() {
    const shippingAddress = {};
    shippingAddress.country = this.countrySelect ? this.countrySelect.value : '';
    shippingAddress.province = this.provinceSelect ? this.provinceSelect.value : '';
    shippingAddress.zip = this.zip ? this.zip.value : '';

    const queryString = Object.keys(shippingAddress)
      .map(key => `${encodeURIComponent(`shipping_address[${key}]`)}=${encodeURIComponent(shippingAddress[key])}`)
      .join('&');

    fetch(`${Shopify.routes.cart_url}/shipping_rates.json?${queryString}`)
      .then(response => response.json())
      .then(data => this.displayRates(data));
  }

  displayRates(rates) {
    const propertyName = Object.keys(rates);
    this.clearRates();

    if (propertyName[0] === 'shipping_rates') {
      rates.shipping_rates.forEach(rate => {
        const rateLi = document.createElement('li');
        rateLi.innerHTML = `${rate.name}: ${this.formatPrice(rate.price)}`;
        this.rates.appendChild(rateLi);
      });

      if (rates.length > 1) {
        this.message.innerHTML = `${Shopify.translation.additional_rates_part_1} ${rates.length} ${Shopify.translation.additional_rates_part_2} ${this.zip.value}, ${this.provinceSelect.value}, ${this.countrySelect.value}, ${Shopify.translation.additional_rates_part_3} ${this.formatPrice(rates[0].price)}`;
      } else {
        this.message.innerHTML = `${Shopify.translation.additional_rate} ${this.zip.value}, ${this.provinceSelect.value}, ${this.countrySelect.value}, ${Shopify.translation.additional_rate_at} ${this.formatPrice(rates.shipping_rates[0].price)}`;
      }

      this.response.classList.add('shipping-rates--display-rates');
    } else {
      this.message.innerHTML = `Error: ${propertyName[0]} ${rates[propertyName[0]]}`;
      this.response.classList.add('shipping-rates--display-error');
    }
  }

  clearRates() {
    this.response.classList.remove('shipping-rates--display-error', 'shipping-rates--display-rates');
    this.message.innerHTML = '';
    this.rates.innerHTML = '';
  }

  formatPrice(price) {
    let formattedPrice;

    if (Currency.display_format === 'money_with_currency_format') {
      formattedPrice = `<span class="money">${Currency.symbol}${price} ${Currency.iso_code}</span>`;
    } else {
      formattedPrice = `<span class="money">${Currency.symbol}${price}</span>`;
    }

    return formattedPrice;
  }

  onSectionUnload() {
    this.events.unregisterAll();
    this.quantitySelectors.forEach(selector => selector.unload());
  }
}
